import { Bed, Sun, type LucideIcon } from "lucide-react";
import type { StayPlanModule } from "@/lib/daycare-hotel/stayPlans";

export interface PlanTone {
  Icon: LucideIcon;
  /** Ladrilho do ícone no cabeçalho do card. */
  tile: string;
  /** Chip que nomeia o módulo ao lado do título. */
  chip: string;
  /** Texto de destaque: o número do saldo. */
  accent: string;
  /** Preenchimento das barras do medidor compacto. */
  bar: string;
}

/**
 * O design separa creche e hotel por cor — laranja e roxo — no ladrilho, no
 * chip e no número do saldo. Um card genérico para os dois deixava os dois
 * planos de um mesmo pet indistinguíveis à primeira vista.
 */
export const PLAN_TONE: Record<StayPlanModule, PlanTone> = {
  daycare: {
    Icon: Sun,
    tile: "bg-orange-50 text-primary",
    chip: "border-orange-200 bg-orange-50 text-state-danger",
    accent: "text-primary",
    bar: "bg-primary",
  },
  hotel: {
    Icon: Bed,
    tile: "bg-purple-50 text-purple-500",
    chip: "border-purple-100 bg-purple-50 text-purple-600",
    accent: "text-purple-500",
    bar: "bg-purple-500",
  },
};
